export default __webpack_public_path__ + "74d6ec9dd3d73b031a62788bc378f759.svg";